import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { useEffect } from "react";

/*
 * NotFoundPage  -  shown for any route that doesn't match.
 * Uses the portfolio's dark/magenta aesthetic so it feels native.
 */
const NotFoundPage = () => {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="min-h-screen bg-ink-950 text-zinc-100 flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-magenta-300 mb-6">
          Error 404
        </div>

        <h1 className="font-display tracking-tight text-7xl sm:text-8xl text-white leading-none">
          404
        </h1>

        <p className="mt-6 text-lg text-zinc-400 leading-relaxed">
          This page drifted off the map. It may have moved, been renamed, or
          never existed in the first place.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-xl bg-magenta-500 text-ink-950 px-5 py-3 text-sm font-semibold hover:bg-magenta-300 transition-colors"
          >
            <Home className="w-4 h-4" />
            Back to home
          </Link>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 rounded-xl border border-edge-700 px-5 py-3 text-sm font-semibold text-zinc-300 hover:text-white hover:border-magenta-500/40 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Read the blog
          </Link>
        </div>

        <div className="mt-16 font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-600">
          malickecase.com
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
